import { render, staticRenderFns } from "./ComplaintOverview.vue?vue&type=template&id=778f69d9&"
import script from "./ComplaintOverview.vue?vue&type=script&lang=js&"
export * from "./ComplaintOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports